import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PulseMark } from "@/components/brand/Logo";

const Loader = () => (
  <div className="fixed inset-0 grid place-items-center bg-white">
    <div className="grid place-items-center rounded-2xl bg-pulse-navy p-5 heartbeat-anim">
      <PulseMark size={40} color="#FFFFFF" />
    </div>
  </div>
);

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (adminOnly && !isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}
